'use client';

import { createContext, useContext } from 'react';

/**
 * Where Dynamic's EVM connector chunk is. Until it is `ready` the auth flow
 * has no wallets to offer, so connect controls stay disabled; `failed` means
 * every attempt to load it was refused and only a reload can help.
 *
 * Kept apart from `wallet-runtime-provider.tsx` on purpose: connect controls
 * across the app read this, and importing the runtime module would pull the
 * Dynamic SDK and the wagmi config into each of them.
 */
export type WalletConnectorsStatus = 'loading' | 'ready' | 'failed';

/**
 * `WalletRuntimeProvider` always provides an explicit value, and it wraps
 * every route. The default only applies to a render with no wallet runtime
 * at all, where there is nothing to wait for, so it changes nothing.
 */
export const WalletConnectorsStatusContext =
  createContext<WalletConnectorsStatus>('ready');

/** Whether a click on a connect control can actually reach a wallet. */
export function useWalletConnectorsStatus(): WalletConnectorsStatus {
  return useContext(WalletConnectorsStatusContext);
}
